import axios from "axios";

export const getPagesByCourses = async ({ token, baseURL, courseids = [] }) => {
  try {
    const courseParams = courseids
      .map((id, i) => `courseids[${i}]=${id}`)
      .join("&");
    const { data } = await axios.get(
      `${baseURL}/webservice/rest/server.php?wstoken=${token}&moodlewsrestformat=json&wsfunction=mod_page_get_pages_by_courses&${courseParams}`
    );
    console.log("mod_page_get_pages_by_courses →", data);
    return data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const setActivityProgressCompletedManually = async (args) => {
  try {
    const { token, cmid, completed, baseURL } = args;
    const { data } = await axios.get(
      `${baseURL}/webservice/rest/server.php?wstoken=${token}&moodlewsrestformat=json&wsfunction=core_completion_update_activity_completion_status_manually&cmid=${cmid}&completed=${completed}`
    );
    /*     console.log(data) */
    return data;
  } catch (e) {
    throw new Error(e.message);
  }
};
